import { Injectable } from '@angular/core';
declare let Blowfish: any;
import { ApiService } from './api.service';
import { StateService } from './state.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  defaultLogin = '7967820340147F45';
  
  constructor(private apiservice: ApiService, private http: HttpClient, private stateSvc: StateService) { }
  
  /**
   * @param username:string, password:string
   * Hash password using blowfish
   * @return user object
   */
  login(username, password): Observable <any>{
	// concate username and password as single string, trim to remove empty spaces before first character and after last character
	let credentials = (username.trim() + '|' + password.trim());
	// encrypt using blowfish library
	let hash = this.hashBlowfish(credentials);
	
	// get URL Endpoint from APIService
	let endpoint = this.apiservice.getEndpointUrl();
	let httpOptions = this.apiservice.getHttpHeader();
	// set full URL to be requested
	let fullPathUrl = endpoint + 'GetLogin/' + hash;
	
	// send to backend via API service, standard place to perform HTTP transfer
	return this.http.get(fullPathUrl)
	.pipe(
		map((results:any) => {
			let user:any = {};
			if (results.length == 0) {
				// no user found from backend
				throw new Error('Invalid Username or Password');
				return user;
			}
			// set user object
			user = this.apiservice.wsr2obj(results[0]);
			user.username = username;
			user.owner = username;
			user.source = "oncore";
			user.hash = this.hashBlowfish(username);
			if(user.subaccount) {
				user.hash = this.hashBlowfish(user.subaccountowner);
				user.owner = user.subaccountowner;
			}
			if(user.subaccount && !moment().isBetween(user.subaccountdatestart, user.subaccountdateend)) {
				throw new Error('Subaccount Expired.');
			}
			
			// init empty zone & POI before call backend API
			user.zones = [];
			user.pois = [];
			
			return user;
		}),
		catchError((error:any) => {
			return throwError(error);
		})
	);
  }
  
  getUserZones(username): Observable <any>{
	let zonesData:any = [];
	let hash = this.hashBlowfish(username);
	let endpoint = this.apiservice.getEndpointUrl();
	let fullPathZoneUrl = endpoint + 'GetZoneUser/' + hash;
	return this.http.get(fullPathZoneUrl)
	.pipe(
		map((zones:any) => {
			zones.forEach((zone) => {
				zonesData.push(this.apiservice.wsr2obj(zone));
			})
			return zonesData;
		}),
		catchError((error:any) => {
			return throwError(error);
		})
	)
  }
  
  getUserPois(username): Observable <any>{
	let poisData:any = [];
	let hash = this.hashBlowfish(username);
	let endpoint = this.apiservice.getEndpointUrl();
	let fullPathPointUrl = endpoint + 'GetPoiUser/' + hash;
	return this.http.get(fullPathPointUrl)
	.pipe(
		map((pois:any) => {
			pois.forEach((poi) => {
				poisData.push(this.apiservice.wsr2obj(poi));
			})
			return poisData;
		}),
		catchError((error:any) => {
			return throwError(error);
		})
	)
  }
  
  /**
   * to hash using blowfish
   */
   hashBlowfish(str){
	// encrypt using blowfish library
	let hash = Blowfish.encrypt(str);
	
	// return hashed string
	return hash;
   }
   
   /**
   * to hash using blowfish
   */
   reversHashBlowfish(hash){
	// encrypt using blowfish library
	let str = Blowfish.decrypt(hash);
	
	// return hashed string
	return str;
   }
   
   storeUserLocally(user){
	user.owner = user.username;
	user.hash = this.hashBlowfish(user.username);
	if(user.subaccount) {
		user.hash = this.hashBlowfish(user.subaccountowner);
		user.owner = user.subaccountowner;
	}
	// master account
	if(user.superuser){
		let tempObj = (user.supernames).split('|');
		user.masterusernames = tempObj;
	}
	// store session locally
	sessionStorage.setItem('user', JSON.stringify(user));
   }
   
   getDefaultLogin(){
	return this.defaultLogin;
   }

   getCredentialData(){
	return this.http.get('assets/.collection.json')
	.pipe(
		map((str) => {
			return str;
		}),
		catchError((error:any) => {
			return throwError(error);
		})
	)
   }

   getOutUsers(username, key, baseUrl) {
		const head = new HttpHeaders()
			// .set('key', key)
			.set('version', '1.0')
			.set('Accept-Language', 'en')
			.set('key', key);

		return this.http.get(
			baseUrl + 'user/getUserTree',
			{ headers: head }
		)
		.pipe(
			map((users: any) => {
				let exUser:any = {};
				exUser = this.findByName(users?.data, username.toLowerCase());
				// if(users?.data[0]?.userName.toLowerCase() == username.toLowerCase()){
				// 	exUser = users?.data[0];
				// 	exUser.username = exUser.userName;
				// 	exUser.owner = exUser.userName;
				// 	exUser.hash = this.hashBlowfish(exUser.userName);
				// 	exUser.source = "bsj";
				// }else if(users?.data[0]?.children?.length > 0){
				// 	users.data[0].children.forEach((chld:any) => {
				// 		if(chld.userName.toLowerCase() == username.toLowerCase()){
				// 			exUser = chld;
				// 			exUser.username = exUser.userName;
				// 			exUser.owner = exUser.userName;
				// 			exUser.hash = this.hashBlowfish(exUser.userName);
				// 			exUser.source = "bsj";
				// 			return;
				// 		}
				// 	});
				// }
				if(!exUser){
					throw new Error('Invalid Username or Password');
				}else{
					exUser.username = exUser.userName;
					exUser.owner = exUser.userName;
					exUser.hash = this.hashBlowfish(exUser.userName);
					exUser.source = "bsj";
				}
				exUser.zones = [];
				exUser.pois = [];
				return exUser;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	getOutUserNames(key, baseUrl,subUsers) {
		const head = new HttpHeaders()
			// .set('key', key)
			.set('version', '1.0')
			.set('Accept-Language', 'en')
			.set('key', key);

		return this.http.get(
			baseUrl + 'user/getUserTree',
			{ headers: head }
		)
		.pipe(
			map((users: any) => {
				let exUsers:any = [];
				subUsers.forEach((susrname) => {
					let unode:any = this.findByName(users.data, susrname);
					if(unode){
						exUsers.push({id:unode?.id, name:unode?.userName});
					}
				});
				// exUsers = this.getAllNames(users.data);
				// users.data[0].children.forEach((chld:any) => {
				// 	if(subUsers.includes((chld.userName).toLowerCase())){
				// 		exUsers.push({id:chld?.id, name:chld?.userName});
				// 	}
				// });
				return exUsers;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	getOutTrackUserNames(subUsers) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.user.child.list",
			"target" : "rightontrack",
			"access_token": this.stateSvc.getTraksolidtoken(),
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.getTimeStamp()
		};

		let readyQuery = this.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		return this.http.post(
			"https://us-open.tracksolidpro.com/route/rest",
			queryString,
			httpOptions
		)
		.pipe(
			map((users: any) => {
				let exUsers:any = [];
				subUsers.forEach((susrname) => {
					let exUser:any = {};
					if(users?.code == 0){
						users?.result?.forEach((chld:any) => {
							if(chld.account.toLowerCase() == susrname.toLowerCase()){
								exUsers.push({id:chld?.userId, account:chld?.account});
								return;
							}
						});
					}
				});
				return exUsers;

				// let exUser:any = {};
				// // exUser = this.findByName(users?.data, username.toLowerCase());
				// if(users?.code == 0){
				// 	users?.result?.forEach((chld:any) => {
				// 		if(chld.account.toLowerCase() == username.toLowerCase()){
				// 			exUser = chld;
				// 			exUser.username = exUser.account;
				// 			exUser.owner = exUser.account;
				// 			exUser.hash = this.hashBlowfish(exUser.account);
				// 			exUser.source = "tracksolid";
				// 			return;
				// 		}
				// 	});
				// }
				// if(!exUser){
				// 	throw new Error('Invalid Username or Password');
				// }else{
				// 	exUser.username = exUser.account;
				// 	exUser.owner = exUser.account;
				// 	exUser.hash = this.hashBlowfish(exUser.account);
				// 	exUser.source = "tracksolid";
				// }
				// exUser.zones = [];
				// exUser.pois = [];
				// return exUser;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	findByName(nodes:any, target:any): Node | null {
		for (const node of nodes) {
			if (node.userName.toLowerCase() === target) {
				return node;
			}

			if (node.children?.length) {
				const found = this.findByName(node.children, target);
				if (found) {
					return found;
				}
			}
		}
		return null;
	}

	getAllNames(nodes: any[], result: string[] = []): string[] {
		for (const node of nodes) {
			let unode:any = {id:node?.id, name:node?.userName};
			result.push(unode);

			if (node.children?.length) {
				this.getAllNames(node.children, result);
			}
		}
		return result;
	}

	getAccessTokenTrack(){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.oauth.token.get",
			"user_id" : "rightontrack",
			"user_pwd_md5": "dac68fa23c6b8f2b128e602c3cc9cf8c",
			"expires_in" : 7200,
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.getTimeStamp()
		};

		let readyQuery = this.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		if(this.stateSvc.tokenExpiryChecker()){
			let result = this.stateSvc.getAllTokenData();
			let returnObj:any = {
				code: 0,
				result: result
			};
			return of(returnObj);
		}else{
			return this.http.post(
				"https://us-open.tracksolidpro.com/route/rest",
				queryString,
				httpOptions
			)
			.pipe(
				map((users: any) => {
					return users;
				})
			);
		}
	}

	getTimeStamp(){
		const formatter = new Intl.DateTimeFormat('en-US', {
			timeZone: 'Asia/Singapore', // GMT+8
			year: 'numeric', month: '2-digit', day: '2-digit',
			hour: '2-digit', minute: '2-digit', second: '2-digit',
			hour12: false
		});

		const parts = formatter.formatToParts(new Date());

		const getPart = (type: Intl.DateTimeFormatPartTypes): number => {
			const part = parts.find(p => p.type === type);
			return part ? parseInt(part.value, 10) : 0;
		};

		const gmt8Date = new Date(
			getPart('year'),
			getPart('month') - 1,
			getPart('day'),
			getPart('hour'),
			getPart('minute'),
			getPart('second')
		);

		gmt8Date.setHours(gmt8Date.getHours() - 8);

		const pad = (num: number): string => String(num).padStart(2, '0');

		const finalStr: string = 
		`${gmt8Date.getFullYear()}-${pad(gmt8Date.getMonth() + 1)}-${pad(gmt8Date.getDate())} ` +
		`${pad(gmt8Date.getHours())}:${pad(gmt8Date.getMinutes())}:${pad(gmt8Date.getSeconds())}`;

		return finalStr;
	}

	processDataObject(data){
		const searchParams = new URLSearchParams(data as any);
		const paramsObj:any = {};

		// Manually build the object instead of using Object.fromEntries()
		searchParams.forEach((value, key) => {
			paramsObj[key] = value;
		});

		// 2. Sort the keys alphabetically (equivalent to ksort)
		const sortedKeys = Object.keys(paramsObj).sort();

		// 3. Concatenate keys and values into a single string
		let finalStr = '';
		for (const key of sortedKeys) {
			finalStr += key + paramsObj[key];
		}

		const secret = "526db42b577047c79e8099b7f8f82d57";
		const signed = CryptoJS.MD5(secret + finalStr + secret).toString();

		data.sign = signed;
		data.sign_method = "md5";
		
		return data;
	}

	generateExpiryTracksoliToken(tokens){
		// Your input variables
		const timeStr = tokens.time;
		const expiresInSeconds = tokens.expiresIn; // 2 hour

		// 1. Parse the string into a Date object. 
		// Replacing space with 'T' creates a valid ISO-8601 string for reliable parsing.
		let expiryDate = new Date(timeStr.replace(' ', 'T') + '+00:00');
		expiryDate.setTime(expiryDate.getTime() + 28800000);

		// 2. Add 'expiresIn' seconds and subtract 10 minutes (600 seconds)
		// Net change: +3600 seconds - 600 seconds = +3000 seconds
		expiryDate.setSeconds(expiryDate.getSeconds() + expiresInSeconds - 600);

		return expiryDate;
		// // 3. Format the new date back to 'Y-m-d H:i:s'
		// const pad = (num: number): string => String(num).padStart(2, '0');

		// const bufferExpiryTime: string = 
		// `${expiryDate.getFullYear()}-${pad(expiryDate.getMonth() + 1)}-${pad(expiryDate.getDate())} ` +
		// `${pad(expiryDate.getHours())}:${pad(expiryDate.getMinutes())}:${pad(expiryDate.getSeconds())}`;

		// console.log(bufferExpiryTime);
	}

	getTrackSolidUsers(username) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};

		let data:any = {
			"method" :"jimi.user.child.list",
			"target" : "rightontrack",
			"access_token": this.stateSvc.getTraksolidtoken(),
			"app_key" : "8FB345B8693CCD0070457A5B735B3D30339A22A4105B6558",
			"v" : "0.9",
			"format" :"json",
			"timestamp": this.getTimeStamp()
		};

		let readyQuery = this.processDataObject(data);
		const queryString: string = new URLSearchParams(readyQuery as any).toString();

		return this.http.post(
			"https://us-open.tracksolidpro.com/route/rest",
			queryString,
			httpOptions
		)
		.pipe(
			map((users: any) => {
				let exUser:any = {};
				// exUser = this.findByName(users?.data, username.toLowerCase());
				if(users?.code == 0){
					this.stateSvc.setTempTrackSolidUsers(users?.result);
					users?.result?.forEach((chld:any) => {
						if(chld.account.toLowerCase() == username.toLowerCase()){
							exUser = chld;
							exUser.username = exUser.account;
							exUser.owner = exUser.account;
							exUser.hash = this.hashBlowfish(exUser.account);
							exUser.source = "tracksolid";
							return;
						}
					});
				}
				if(!exUser){
					throw new Error('Invalid Username or Password');
				}else{
					exUser.username = exUser.account;
					exUser.owner = exUser.account;
					exUser.hash = this.hashBlowfish(exUser.account);
					exUser.source = "tracksolid";

					const children = this.getAllTrackChildren(
						exUser.userId,
						users?.result
					);

					const accounts = [
						exUser,
						...children
					];
					this.stateSvc.setTrackSolidAccounts(accounts);
				}
				exUser.zones = [];
				exUser.pois = [];
				return exUser;
			}),
			catchError((error:any) => {
				console.log('error',error)
				return throwError(error);
			})
		);
	}

	getAllTrackChildren(userId: string, users: any[]): any[] {
		const children = users.filter(
			user => user.parentId === userId
		);

		let result: any[] = [...children];

		for (const child of children) {
			result = result.concat(
			this.getAllTrackChildren(child.userId, users)
			);
		}

		return result;
	}
}
